import React from 'react';
import { AppBar, Button, Container, Tab, Tabs, Toolbar, Typography } from '@material-ui/core';
import HeaderBar from './HeaderBar';
import NavigationTabs from './NavigationTabs';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { makeStyles } from '@material-ui/core/styles';
import casegrafWordmark from './images/casegraf-wordmark.svg';

const useStyles = makeStyles({
  appBarStyle: {
    padding: '10px',
    borderBottom: 1,
    borderColor: "primary",
  },
  casegrafLogoStyle: {
    height: '50px',
  },
  buttonStyle: {
    margin: '10px',
    fontWeight: 'bold',
  },
});

export default function App() {
  const classes = useStyles();
  const { isLoading, isAuthenticated, loginWithRedirect, user } = useAuth0();

  if (isLoading) {
    console.log('loading');
    console.log(isLoading);
    return (
      <Container>
        <Typography variant='h6'>Loading</Typography>
      </Container>
    );
  }

  if (!isAuthenticated) {
    loginWithRedirect();
  }

  if (isAuthenticated) {
    console.log('user');
    console.log(user);
    return (
      <Container maxWidth='md'>
        <HeaderBar />
        <Toolbar />
        <Toolbar />
        <Switch>
          <Redirect exact from='/' to='/my-cases' />
          <Route exact path='/:page?' render={props => <NavigationTabs {...props} /> }/>
        </Switch>
      </Container>
    );
  }

  return (
    <Container />
  );
}
